export enum VatStatementStatus {
Draft,
Submitted,
Cancelled,
}
